import * as React from 'react';
import { RoomEventItem } from '../../../Types/RoomEvent';
import { setModalData } from '../../Shared/SharedSlices/ModalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setRoomEventsData } from '../RoomSlices/RoomEventsSlice';
import { RootState } from '../../../App/store';
import Image from "../../Shared/Primitive/Image"
import { formatDate } from '../../../App/Helpers/Helpers';

const getDescriptionPreview = (description: string) => {
    const plainText = description.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()

    if (plainText.length <= 140) {
        return plainText
    }

    return `${plainText.slice(0, 137).trimEnd()}...`
}

const getEventSourceName = (event: RoomEventItem) => {
    if (event.content_object?.name) {
        return event.content_object.name
    }

    if (event.content_object?.first_name || event.content_object?.last_name) {
        return `${event.content_object.first_name ?? ''} ${event.content_object.last_name ?? ''}`.trim()
    }

    return null
}

const RoomEventListItem: React.FC<{ event: RoomEventItem }> = ({ event }) => {
    const roomEventsData = useSelector((state: RootState) => state.roomEventsSlice)
    const dispatch = useDispatch()
    const descriptionPreview = getDescriptionPreview(event.description)
    const eventSourceName = getEventSourceName(event)
    const detailItems = [event.location_type, event.formats, event.admission].filter(Boolean)

    const onItemClick = () => {
        dispatch(setRoomEventsData({ ...roomEventsData, selectedItem: event }))
        dispatch(setModalData({ open: true, roomEventModal: true }))
    }

    return (
        <div onClick={onItemClick} key={event.id} className="room-events__item">
            <div className='room-events__item-left-panel'>
                <div className="room-events__item-date room-events__item-date-small">
                    <div className='room-events__item-date-day'>
                        {new Date(event.start_date).toLocaleDateString(undefined, { day: 'numeric' })}
                    </div>
                    <div className='room-events__item-date-month'>
                        {new Date(event.start_date).toLocaleDateString(undefined, { month: 'short' })}
                    </div>
                </div>
            </div>
            <div className='room-events__item-middle-panel'>
                <div className="room-events__image-frame">
                        {event?.image ? (<Image src={event.image} className="room-events__image" style={{ objectPosition: `${event.image_position_x ?? 50}% ${event.image_position_y ?? 50}%` }} />) : (
                            <Image src="/event_default.png" className="room-events__image" />
                        )}
                    </div>
            </div>
            <div className='room-events__item-right-panel'>
                <div className='room-events__item-meta'>
                    <div className='room-events__item-date-range'>
                        {formatDate(event.start_date, 'dd.MM.yyyy HH:mm')}
                        {event.end_date && event.end_date !== event.start_date && (
                            <> - {formatDate(event.end_date, 'dd.MM.yyyy HH:mm')}</>
                        )}
                    </div>
                    {eventSourceName && <div className='room-events__item-source'>{eventSourceName}</div>}
                </div>
                <div className="room-events__item-title"><h4>{event.title}</h4></div>
                <div className="room-events__tags">
                    {event?.keywords?.map((keyword, index) => (
                        <div key={index} className="room-events__tag">{keyword}</div>
                    ))}
                </div>
                {descriptionPreview && (
                    <div className="room-events__item-description">{descriptionPreview}</div>
                )}
                <div className='room-events__details'>
                    {detailItems.map((detailItem) => (
                        <span key={detailItem} className="room-events__detail-chip">{detailItem}</span>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default RoomEventListItem